import { Loader2 } from 'lucide-react';
import { cn } from '../../lib/cn';

export interface SpinnerProps {
  className?: string;
  label?: string;
}

export const Spinner = ({ className, label }: SpinnerProps) => (
  <Loader2
    aria-hidden={label ? undefined : true}
    aria-label={label}
    role={label ? 'status' : undefined}
    className={cn('size-4 animate-spin', className)}
  />
);
